<ng-container
    #bonusList="userBonusList"
    #user="user"
    lsUser
    lsUserBonusList
>
    @if (user.userBalanceInfo$ | async; as userBalance) {
        <div
            class="profile-balance__info-wrapper"
            lsUiListenToOutsideClick
            (lsOnClickOutside)="status = false"
        >
            <button
                class="profile-balance__info-btn"
                [class._active]="status"
                type="button"
                (click)="toggleDropdown()"
            >
                <div class="profile-balance__info-coins">
                    <ls-picture
                        class="profile-balance__info-coins-icon"
                        src="balance/lp"
                    />
                    {{ userBalance.loyalty }}
                </div>

                <span class="profile-balance__info-btn-val">
                        {{ userBalance | sumBalance | uiCurrency : { currencyCode: userBalance.currency } }}
                    </span>

                <ls-ui-icon
                    class="profile-balance__info-btn-icon"
                    height="24"
                    src="chevron"
                    width="24"
                />
            </button>

            <div class="profile-balance__info">
                @if (userBalance.balance !== null && userBalance.balance !== undefined && userBalance.bonus !== null && userBalance.bonus !== undefined) {
                    <div class="profile-balance__info-item">
                        <span class="profile-balance__info-label _system-p _system-p-sm _400">{{ "common.total-balance" | translate }}</span>

                        <div class="profile-balance__info-value _system-p _system-p-sm _600">
                            @if (userBalance.bonus_sport) {
                                <span>{{ userBalance | sumBalance | uiCurrency : { currencyCode: userBalance.currency } }}</span>
                                <ls-picture
                                    class="profile-balance__info-icon"
                                    src="balance/tms"
                                />
                            } @else {
                                <span>{{ userBalance | sumBalance | uiCurrency : { currencyCode: userBalance.currency } }}</span>
                                <ls-picture
                                    class="profile-balance__info-icon"
                                    src="balance/tm"
                                />
                            }
                        </div>
                    </div>
                }

                @if (userBalance.balance !== null && userBalance.balance !== undefined) {
                    <div class="profile-balance__info-item">
                        <span class="profile-balance__info-label _system-p _system-p-sm _400">{{ "common.cash-balance" | translate }}</span>

                        <div class="profile-balance__info-value _system-p _system-p-sm _600">
                            <span>{{ userBalance.balance | uiCurrency : { currencyCode: userBalance.currency } }}</span>
                            <ls-picture
                                class="profile-balance__info-icon"
                                src="balance/rm"
                            />
                        </div>
                    </div>
                }

                @if (userBalance.bonus !== null && userBalance.bonus !== undefined) {
                    <div class="profile-balance__info-item">
                        <span class="profile-balance__info-label _system-p _system-p-sm _400">
                            {{ (userBalance.bonus_sport ? "common.sport-balance" : "common.bonus-balance") | translate }}
                        </span>

                        <div
                            class="profile-balance__info-value _system-p _system-p-sm _600 _bonus"
                            [class._bonus-sport]="userBalance.bonus_sport"
                        >
                            @if (userBalance.bonus_sport) {
                                <span>{{ userBalance.bonus_sport | uiCurrency : { currencyCode: userBalance.currency } }}</span>
                                <ls-picture
                                    class="profile-balance__info-icon"
                                    src="balance/sm"
                                />
                            } @else {
                                <span>{{ userBalance.bonus | uiCurrency : { currencyCode: userBalance.currency } }}</span>
                                <ls-picture
                                    class="profile-balance__info-icon"
                                    src="balance/bm"
                                />
                            }

                        </div>
                    </div>
                }

                <span class="profile-balance__info-item">
                        <span class="profile-balance__info-label _system-p _system-p-sm _400">{{ "common.coin" | translate }}</span>
                        <div class="profile-balance__info-value _system-p _system-p-sm _600">
                            <span>{{ userBalance.loyalty }}</span>
                            <ls-picture
                                class="profile-balance__info-icon"
                                src="balance/lp"
                            />
                        </div>
                    </span>

                <ng-container *lsUiNgLet="bonusList.activeBonus$ | async as activeBonus">
                    @if (activeBonus) {
                        <hr class="profile-balance__info-hr">
                        <span class="profile-balance__info-item">
                                <span class="profile-balance__info-label _system-p _system-p-sm _400">{{ 'common.bonus-wagering' | translate }}</span>
                                <span class="profile-balance__info-value _system-p _system-p-sm _600">{{ activeBonus | bonusPercent }}
                                    %</span>
                            </span>
                        <span class="profile-balance__info-progress-wrapper">
                            <span class="profile-balance__info-progress-inner">
                                <span
                                    class="profile-balance__info-progress"
                                    [style]="'--progress-percent-value: calc(' + (activeBonus | bonusPercent) + '% + var(--progress-out-space))'"
                                ></span>
                            </span>
                        </span>
                    }
                </ng-container>
            </div>
        </div>
    }

    <ng-container *ngTemplateOutlet="depositBigButtonTemplate"/>
</ng-container>

<ng-template #depositBigButtonTemplate>
    <button
        (click)="openPaymentWindow()"
        [class._themed]="eventTheme | checkEventThemePipe"
        [name]="'common.button-deposit' | translate"
        class="profile-balance__deposit-btn"
        lsUiButtonKind="primary"
        lsUiButtonPalette="accent-1"
        lsUiButtonSize="small"
    >
        {{ 'common.button-deposit' | translate }}
    </button>
</ng-template>
